import styled, { css } from 'styled-components';
import DropImg from '../assets/icons/drop.png';
import { cinza, corPrincipal } from './constants/colors';
import { bordaArredondar, espacamento } from './constants/sizes';

/* LAYOUT */

export const A11yButtonsContainer = styled.div`
  position: fixed;
  left: 0;
  width: 250px;
  z-index: 9;
  display: flex;
  justify-content: center;
  grid-gap: 10px;
  background-color: #e5e5e5;
  padding: 5px 15px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;

  button {
    background-color: #8b8b8b;
    border: none;
    cursor: pointer;
    padding: 4px 5px;
    border-radius: 4px;
  }

  svg {
    width: 1.5em;
    height: 1.5em;
    fill: #fff;
  }

  @media screen and (max-width: 801px) {
    bottom: 36px;
    width: 190px;
    border-top-right-radius: 14px;
  }
`;

export const A11yContainerControl = styled.div`
  ${(props) => props.contrast
    && css`
      .controle-fundo {
        background-color: #000 !important;

        a, button {
          background-color: #000 !important;
          color: #fff !important;
        }

        svg {
          fill: #fff !important;
        }

        p, h1, h2, h3, h4, h5, h6, span, label, b, small {
          color: #fff !important;
        }

        select {
          background-color: #fff !important;
        }

        .controle-secretaria {
          background-color: #000 !important;

          img {
            filter: contrast(0) !important;
          }
        }
      }

      .controle-modal {
        border: 1px solid #fff;
      }
    `};
`;

export const AppFragment = styled.div``;

export const AppBody = styled.div`
  position: fixed;
  padding-top: ${espacamento.pequeno}px;
  padding-bottom: ${espacamento.grande}px;
  top: 0;
  right: 0;
  bottom: 0;
  left: ${(props) => (props.totem ? '0px' : '200px')};
  overflow: auto;
  overflow-x: hidden;
  overflow-y: ${({ desfoque }) => (desfoque ? 'hidden' : 'auto')};
  filter: ${({ desfoque }) => (desfoque ? 'blur(2px)' : null)};
  transform: translate3d(0, 0, 0);

  @media screen and (max-width: 1450px) {
    left: ${(props) => (props.totem ? '0px' : '250px')};
  }

  @media screen and (max-width: 800px) {
    top: 65px;
    left: 0;
    padding-bottom: 100px;
  }
`;

export const AppBodyTotem = styled.div`
  padding-top: ${espacamento.extraGrande}px;
  padding-bottom: ${espacamento.extraGrande}px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: ${({ desfoque }) => (desfoque ? 'hidden' : 'auto')};
  filter: ${({ desfoque }) => (desfoque ? 'blur(2px)' : null)};
  transform: translate3d(0, 0, 0);
  padding-top: ${({ totemCadastro }) => (totemCadastro ? '100px' : '130px')};
`;

export const AppBodyForm = styled.div`
  position: fixed;
  padding-top: ${espacamento.pequeno}px;
  padding-bottom: ${espacamento.extraGrande}px;
  top: 0;
  right: 0;
  bottom: 0;
  left: ${(props) => (props.totem ? '260px' : '-10px')};
  overflow: scroll;
  overflow-x: hidden;
  filter: ${({ desfoque }) => (desfoque ? 'blur(2px)' : null)};
  transform: translate3d(0, 0, 0);

  @media screen and (max-width: 800px) {
    top: 65px;
    left: 0;
  }
`;

export const BreadCumbs = styled.div`
  position: absolute;
  top: 83px;
  left: 280px;
  border-bottom: 1px solid #00000024;
  padding-bottom: 7px;
  font-size: 19px;
  color: #6a6969;
  width: 70%;
`;

export const Container = styled.div`
  max-width: ${(props) => (props.totem ? '1450px' : '1200px')};
  margin-right: auto;
  margin-left: auto;
  padding-left: ${(props) => (props.totemLogin ? '10px' : '3%')};
  padding-right: 3%;
  padding-top: ${espacamento.pequeno}px;

  h1 {
    font-size: 1.1em;
    border-bottom: 1px solid #dededd;
    padding-bottom: ${espacamento.extraPequeno}px;
    margin-bottom: ${espacamento.medio}px;
  }

`;

export const ContainerCadastroTotem = styled.div`
  max-width: 1450px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 3%;
  padding-right: 3%;

  h1 {
    font-size: 1.1em;
    border-bottom: 1px solid #dededd;
    padding-bottom: ${espacamento.extraPequeno}px;
    margin-bottom: ${espacamento.medio}px;
  }

`;

export const ContainerTotem = styled.div`
  max-width: 1550px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 3%;
  padding-right: 3%;
  min-height: 100vh;
  display: grid;
  align-items: center;
  justify-content: center;

  h1 {
    font-size: 1.1em;
    border-bottom: 1px solid #dededd;
    padding-bottom: ${espacamento.extraPequeno}px;
    margin-bottom: ${espacamento.medio}px;
  }

`;

export const ContainerSelecao = styled.div`
  max-width: ${(props) => (props.totem ? '1550px' : '1200px')};
  margin-right: auto;
  margin-left: auto;
  padding-left: 3%;
  padding-right: 3%;
  padding-top: ${espacamento.pequeno}px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-itens: center;
  justify-content: center;
  min-height: 100vh;

  h1 {
    font-size: 1.1em;
    border-bottom: 1px solid #dededd;
    padding-bottom: ${espacamento.extraPequeno}px;
    margin-bottom: ${espacamento.medio}px;
  }

`;

export const Interno = styled.div`
  margin-right: auto;
  margin-left: auto;

  @media screen and (max-width: 600px) {
    padding-right: 5px;
    padding-left: 5px;
  }
`;

export const Centro = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  margin: 5% auto;
  padding: ${espacamento.pequeno}px;
  flex-direction: column;
`;

export const CentroT = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 55px;
  padding: ${espacamento.pequeno}px;
  flex-direction: column;
  position: absolute/
`;

export const CentroSemPadding = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 15px;
`;

export const Linha = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  padding: ${(props) => ((props.totem) ? '30px 10px !important' : 'unset')};
  margin-left: ${(props) => ((props.totem) ? '10px' : 'unset')};
`;

export const LinhaAnonimo = styled.div`
  width: 257px !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  padding: ${(props) => ((props.totem) ? '30px 10px !important' : 'unset')};
  margin-left: 50px;
`;

export const Coluna = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Divisor = styled.div`
  margin-bottom: ${({ border, size }) => (border && espacamento[size] ? espacamento[size] : espacamento.extraPequeno)}px;
  padding-bottom: ${({ size }) => (size && espacamento[size] ? espacamento[size] : espacamento.extraPequeno)}px;
  border: 0 solid ${cinza.claro};
  border-bottom-width: ${({ border }) => (border ? 1 : 0)}px;
`;

/* FONTES */

export const Titulo = styled.h1`
  color: #898585;
  font-size: ${(props) => ((props.totem) ? '1.5em !important' : 'unset')};
`;

export const Logotipo = styled.strong`
  font-size: 1.4em;
`;

export const NomeCidade = styled.strong`
  font-size: ${(props) => (props.totem ? '1.8em' : '1.2em')};
`;

export const Alerta = styled.span`
  color: #ED5F55;
`;

export const DataTexto = styled.span`
  color: #777;
  font-weight: bold;
`;

/* BOTÕES */

export const BotaoLike = styled.button`
  border: 1px solid #35aeff;
  border-radius: ${bordaArredondar}px;
  outline: none;
  cursor: pointer;
  padding: ${espacamento.ultraPequeno}px ${espacamento.medio}px;
`;

export const BotaoUnlike = styled.button`
  border: 1px solid #f8666e;
  border-radius: ${bordaArredondar}px;
  outline: none;
  cursor: pointer;
  padding: ${espacamento.ultraPequeno}px ${espacamento.medio}px;
`;

export const BotaoLink = styled.button`
  background: transparent;
  font: inherit;
  vertical-align: baseline;
  color: ${corPrincipal};
  border: none;
  cursor: pointer;
`;

export const BotaoLinkLogin = styled.button`
  background: transparent;
  font: inherit;
  vertical-align: baseline;
  color: ${corPrincipal};
  border: none;
  cursor: pointer;

  :hover, :focus, :active {
    text-decoration: underline;
  }
`;

export const BotaoNude = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;
  outline: none;
  align-self: center;
`;

export const BotaoNudePesquisa = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;
  outline: none;
  margin-bottom: 18px;
`;

export const BotaoNudeTotem = styled.button`
  background: transparent;
  padding: 12px;
  margin: 0;
  border: none;
  cursor: pointer;
  outline: none;
  align-self: center;
`;

export const BotaoExcluir = styled.button`
  background-color: #cc0000;
  border-radius: 100px;
  outline: none;
  cursor: pointer;
  align-self: center;
  position: absolute;
  z-index: 1;
  right: 0;
  border: none;
  padding: 2px 5px;
`;

export const BotaoImpressao = styled.button`
  border-radius: 4px;
  padding: ${espacamento.ultraPequeno}px ${espacamento.pequeno}px;
  align-items: center;
  cursor: pointer;
  border: none;
  outline: none;
  color: #fff;
  background-color: #54a0ff;

  :hover {
    background-color: #3467cc;
  }

  @media print {
    display: none;
  }
`;

/* NOTIFICAÇÃO */
export const NotificacaoSucesso = styled.div`
  color: #6d9e64;
  background-color: #d4fecc;
  box-shadow: 0 1px 5px 0 rgba(0,0,0,0.3);
  padding: ${espacamento.pequeno}px ${espacamento.pequeno}px;
  border-radius: 4px;
  margin-bottom: ${espacamento.extraPequeno}px;
  width: 20em;
  max-width: 100%;

  h4 {
    margin-top: 0;
    font-weight: 600;
    font-size: 1.3em;
  }
`;

export const NotificacaoErro = styled.div`
  color: #622428;
  background-color: #ffd3d4;
  box-shadow: 0 1px 5px 0 rgba(0,0,0,0.3);
  padding: ${espacamento.pequeno}px ${espacamento.pequeno}px;
  border-radius: 4px;
  margin-bottom: ${espacamento.extraPequeno}px;
  width: 20em;
  max-width: 100%;

  h4 {
    margin-top: 0;
    font-weight: 600;
    font-size: 1.3em;
  }
`;

export const NotificacaoInfo = styled.div`
  background-color: #fff;
  color: #000;
  box-shadow: 0 1px 5px 0 rgba(0,0,0,0.3);
  padding: ${espacamento.pequeno}px ${espacamento.pequeno}px;
  border-radius: 4px;
  margin-bottom: ${espacamento.extraPequeno}px;
  width: 20em;
  max-width: 100%;

  h4 {
    margin-top: 0;
    font-weight: 600;
    font-size: 1.3em;
  }
`;

export const NotificacaoAviso = styled.div`
  color: #613b13;
  background-color: #f4ca7b;
  box-shadow: 0 1px 5px 0 rgba(0,0,0,0.3);
  padding: ${espacamento.pequeno}px ${espacamento.pequeno}px;
  border-radius: 4px;
  margin-bottom: ${espacamento.extraPequeno}px;
  width: 20em;
  max-width: 100%;

  h4 {
    margin-top: 0;
    font-weight: 600;
    font-size: 1.3em;
  }
`;

/* FORMULÁRIO */

export const CampoForm = styled.input`
  flex: 1;
  letter-spacing: 1px;
  font: inherit;
  padding: ${espacamento.extraPequeno}px;
  padding-right: ${({ campoSenha }) => ((campoSenha && (campoSenha === 'S' || campoSenha === 'text')) ? '42' : espacamento.extraPequeno)}px;
  border: 1px solid ${cinza.claro};
  border-radius: ${bordaArredondar}px;
  transition: .2s ease-in-out;
  backface-visibility: hidden;
  height: ${(props) => (props.totem ? '55px' : 'unset')};
  outline: none;
  box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  width: 100%;

  :focus {
    border-color: #2a7ae2;
    box-shadow: 0 2px 10px 0 rgba(42, 122, 226, 0.5);
  }
`;

export const CampoFormTotem = styled.input`
  flex: 1;
  letter-spacing: 1px;
  font: inherit;
  font-size: 1.35em !important;
  padding: ${espacamento.extraPequeno}px;
  padding-right: ${({ campoSenha }) => ((campoSenha && (campoSenha === 'S' || campoSenha === 'inputTotemVisualizacao')) ? '44' : espacamento.extraPequeno)}px;
  border: 1px solid ${cinza.claro};
  border-radius: ${bordaArredondar}px;
  transition: .2s ease-in-out;
  backface-visibility: hidden;
  height: ${(props) => (props.totem ? '55px' : 'unset')};
  outline: none;
  box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  width: 100%;

  :focus {
    border-color: #2a7ae2;
    box-shadow: 0 2px 10px 0 rgba(42, 122, 226, 0.5);
  }
`;

export const CampoFormTotemLogin = styled.input`
  flex: 1;
  letter-spacing: 1px;
  font: inherit;
  font-size: 1.30em !important;
  padding: ${espacamento.extraPequeno}px;
  padding-right: ${({ campoSenha }) => ((campoSenha && (campoSenha === 'S' || campoSenha === 'inputLoginTotemVisualizacao')) ? '47' : espacamento.extraPequeno)}px;
  border: 1px solid ${cinza.claro};
  border-radius: ${bordaArredondar}px;
  transition: .2s ease-in-out;
  backface-visibility: hidden;
  outline: none;
  box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  width: 100%;

  :focus {
    border-color: #2a7ae2;
    box-shadow: 0 2px 10px 0 rgba(42, 122, 226, 0.5);
  }
`;

export const SelectForm = styled.select`
  flex: 1;
  letter-spacing: 1px;
  font: inherit;
  padding: ${espacamento.extraPequeno}px;
  padding-right: ${espacamento.medio}px;
  border: 1px solid ${cinza.claro};
  border-radius: ${bordaArredondar}px;
  background: url(${DropImg}) no-repeat 98%;
  background-size: 10px;
  width: 100%;
  transition: .2s ease-in-out;
  backface-visibility: hidden;
  outline: none;
  box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  appearance: none;
  font-size: .95em;

  :focus {
    border-color: #2a7ae2;
    box-shadow: 0 2px 10px 0 rgba(42, 122, 226, 0.5);
  }
`;

export const SelectFormTotemBairros = styled.input`
  flex: 1;
  letter-spacing: 1px;
  font: inherit;
  padding: ${espacamento.extraPequeno}px;
  padding-right: ${espacamento.medio}px;
  border: 1px solid ${cinza.claro};
  border-radius: ${bordaArredondar}px;
  background-size: 10px;
  width: 100%;
  transition: .2s ease-in-out;
  backface-visibility: hidden;
  outline: none;
  box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  // appearance: none;
  font-size: 1.35em;

  :focus {
    border-color: #2a7ae2;
    box-shadow: 0 2px 10px 0 rgba(42, 122, 226, 0.5);
  }
`;

export const SelectFormTotem = styled.select`
  flex: 1;
  letter-spacing: 1px;
  font: inherit;
  padding: ${espacamento.extraPequeno}px;
  padding-right: ${espacamento.medio}px;
  border: 1px solid ${cinza.claro};
  border-radius: ${bordaArredondar}px;
  background: url(${DropImg}) no-repeat 98%;
  background-size: 10px;
  width: 100%;
  transition: .2s ease-in-out;
  backface-visibility: hidden;
  outline: none;
  box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  appearance: none;
  font-size: 1.35em;

  :focus {
    border-color: #2a7ae2;
    box-shadow: 0 2px 10px 0 rgba(42, 122, 226, 0.5);
  }
`;

export const AreaForm = styled.textarea`
  flex: 1;
  letter-spacing: 1px;
  font: inherit;
  padding: ${espacamento.extraPequeno}px;
  border: 1px solid ${cinza.claro};
  border-radius: ${bordaArredondar}px;
  resize: vertical;
  width: 100%;
  height: 145px;
  transition: .2s ease-in-out;
  backface-visibility: hidden;
  outline: none;
  box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  width: 100%;

  :focus {
    border-color: #2a7ae2;
    box-shadow: 0 2px 10px 0 rgba(42, 122, 226, 0.5);
  }
`;

export const AreaFormTotem = styled.textarea`
  flex: 1;
  letter-spacing: 1px;
  font: inherit;
  padding: ${espacamento.extraPequeno}px;
  border: 1px solid ${cinza.claro};
  border-radius: ${bordaArredondar}px;
  resize: vertical;
  width: 100%;
  height: 245px;
  transition: .2s ease-in-out;
  backface-visibility: hidden;
  outline: none;
  box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  font-size: 1.35em;

  :focus {
    border-color: #2a7ae2;
    box-shadow: 0 2px 10px 0 rgba(42, 122, 226, 0.5);
  }
`;

export const FormFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const FormFooterTotem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const LabelEnquete = styled.label`
  flex: 1;
  background-color: #eaeaea;
  padding: ${espacamento.extraPequeno}px;
`;

/* GRID LAYOUT */

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: ${(props) => (props.totem ? '32px' : '24px')};

  @media screen and (max-width: 1000px) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 300px) {
    grid-template-columns: 1fr;
  }
`;

export const GridArquivos = styled.div`
  display: grid;
  grid-gap: ${(props) => (props.totem ? '32px' : '24px')};
  max-height: 270px;
  overflow-y: auto;
  padding-inline: 7px;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-corner {
    background-color: #fbfaf5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #dfe4ea;
  }

  @media screen and (min-width: 500px) {
    grid-template-columns: repeat(auto-fill, minmax(10em, 1fr));
  }
`;

export const GridInicial = styled.div`
  display: grid;
  grid-gap: ${(props) => (props.totem ? '32px' : '24px')};
  grid-template-columns: repeat(auto-fill,minmax(13em,1fr));
`;

export const GridLoginInicial = styled.div`
  display: flex;
  justify-content: center;
  grid-gap: 15px;

  @media screen and (max-width: 800px) {
    flex-direction: column;
    grid-gap: 10px;
  }
`;

export const GridTotem = styled.div`
  display: flex;
  grid-gap: 62px;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

export const GridNoticias = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: ${espacamento.extraGrande}px;
  grid-row-gap: 30px;

  @media screen and (max-width: 1000px) {
      grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    max-width: 350px;

`;

export const GridColeta = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: ${espacamento.grande}px;
  grid-row-gap: 30px;

  @media screen and (max-width: 1000px) {
      grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }

`;

export const GridTransporteColetivo = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${espacamento.grande}px;
  grid-row-gap: 30px;

  @media screen and (max-width: 1000px) {
      grid-template-columns: 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }

`;

export const GridServicos = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  text-align: center;
  justify-content: center;
  align-items: center;
  // min-height: 43vh;
  grid-gap: ${espacamento.medio}px;

  @media screen and (max-width: 1000px) {
      grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 300px) {
    grid-template-columns: 1fr;
  }

`;

export const GridCartaServicos = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 25px;
  margin-top: 30px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const GridSpaceBetween = styled.div`
  display: flex;
  grid-gap: 20px;
  align-items: center;
  justify-content: space-between;
  margin-block: 40px 30px;

  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
`;

/* MODAL */

export const ContainerJanela = styled.div`
  position: fixed;
  top: 0;
  overflow: visible;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  margin: auto;
  background-color: rgba(0, 0, 0, .3);
  animation: fade-in .3s ease-in-out forwards;
`;

/* LISTA */

export const ListaItem = styled.div`
  background-color: #fff;
  border-radius: ${bordaArredondar}px;
  border: 1px solid ${cinza.claro};
  box-shadow: 0 3px 5px 0 rgb(0 0 0 / 10%);
`;

export const ListaItemHeader = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${espacamento.extraPequeno}px;
  min-width: 100%;
  border: none;
  outline: none;
  cursor: pointer;
  box-shadow: 0 3px 5px 0 rgb(0 0 0 / 10%);
  min-height: 50px;
`;

export const ListaItemBody = styled.div`
  padding: ${espacamento.pequeno}px;
`;

export const LinkBreadCrumb = styled.a`
  font-weight: bold;
  cursor: pointer; 
  color: #6a6969;
  text-decoration: none;
`;

export const TituloAjuda = styled.div`
  background-color: #f6f6f6;
  border-radius: ${bordaArredondar}px;
  border: 1px solid #dededd;
  padding: ${espacamento.extraPequeno}px;
  color: #747474;
`;
